const PREFIX = 'managed-topic:';

/** Identifiant unique côté UI pour une fiche d’aide issue de la base (évite collision avec les ids statiques). */
export function managedHelpTopicClientId(dbTopicId: string): string {
  return `${PREFIX}${dbTopicId}`;
}
